import { useState } from "react";
import { Copy, Check } from "lucide-react";
import ProfileImg from "../../../../shared/ui/icons/ProfileImg";

type Props = {
  name?: string,
  email?: string,
  website?: string,
  img?: string,
  id?: string,
  joined?: string,
  totalUsers?: number,
  lastSeen?: string,
  domain?: string,
};

const AccountProfileAvatar = ({
  name,
  email,
  website,
  img,
  id,
  domain,
}: Props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (id) {
      navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const truncatedId = id && id.length > 18 ? `${id.slice(0, 18)}...` : id;

  return (
    <div className="flex flex-col items-center text-center gap-2">
      <ProfileImg width={56} height={56} desc={email || website || domain} img={img} name={name} />
      <div>
        {name && (
          <h2 className="text-sm font-semibold text-gray-900">{name}</h2>
        )}
        {id && (
          <div className="flex items-center justify-center gap-1.5 mt-1">
            <span className="text-[11px] text-gray-500 font-mono">{truncatedId}</span>
            <button type="button" onClick={handleCopy} className="text-gray-400 hover:text-gray-700 transition-colors">
              {copied ? <Check className="h-3 w-3 text-green-500" /> : <Copy className="h-3 w-3" />}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountProfileAvatar;
